module.exports = __webpack_public_path__ + "img/PaymentKH.3877751d.png";